import React from 'react';
import {
  Badge,
  Box,
  Checkbox,
  colors,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import { translate as t } from 'hooks/useTranslations';
import type { User } from 'views/App/Portal/LexID/Users/_types/user';

type AddUserReviewProps = {
  selectedUsers: User[];
  onRemoveUser: (userId: string) => void;
  searchQuery: string;
};

export default function AddUserReview({ selectedUsers, onRemoveUser, searchQuery }: AddUserReviewProps) {
  const filteredUsers = searchQuery.trim()
    ? selectedUsers.filter(u => {
        const q = searchQuery.toLowerCase();
        return (
          `${u.firstName} ${u.lastName}`.toLowerCase().includes(q) ||
          (u.email || '').toLowerCase().includes(q)
        );
      })
    : selectedUsers;

  return (
    <Stack spacing={2}>
      <TableContainer
        component={Box}
        sx={{
          backgroundColor: colors.grey[100],
          border: 'solid 1px',
          borderColor: colors.grey[200],
          borderRadius: 3,
          clipPath: 'inset(1px round 4px)',
          p: 1,
          overflow: 'auto',
        }}
      >
        <Table sx={{ backgroundColor: '#FFF' }}>
          <TableHead>
            <TableRow>
              <TableCell padding='checkbox' />
              <TableCell>{t('common.name', 'Name')}</TableCell>
              <TableCell>{t('common.email', 'Email')}</TableCell>
              <TableCell>{t('common.active', 'Active')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredUsers.map((user) => (
              <TableRow key={user.id}>
                <TableCell padding='checkbox'>
                  <Checkbox
                    checked={true}
                    onChange={() => onRemoveUser(user.id || '')}
                    size='small'
                  />
                </TableCell>
                <TableCell>{`${user.firstName} ${user.lastName}`}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>
                  <Badge
                    variant='inline'
                    badgeContent={user.active ? t('common.active', 'Active') : t('common.inactive', 'Inactive')}
                    color={user.active ? 'success' : 'error'}
                    sx={{ textTransform: 'uppercase' }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}
